import { useTranslation } from "react-i18next";
import { allAndroidVersions, androidVersionOptions } from "src/data/products";

import { FilterHeader } from "@shared/table/headers/FilterHeader";

type Props = {
    codename: string | null;
    value: number[];
    onChange: (value: number[]) => void;
};

export const MajorVersionHeader = ({ codename, value, onChange }: Props) => {
    const { t } = useTranslation(["common", "modals"]);
    const versions = (codename && androidVersionOptions[codename]) || allAndroidVersions;
    const options = versions.map((version) => ({ key: version, label: t("common:label.androidWithValue", { version }) }));
    const current = value.map(String);

    return (
        <FilterHeader
            title={t("modals:filterDialog.variants.androidVersion")}
            defaultSortOrder="desc"
            options={options}
            initialValues={Object.fromEntries(options.map((o) => [o.key, current.includes(o.key)]))}
            onSubmit={(values) => {
                const numbers = Object.keys(values)
                    .filter((k) => values[k])
                    .map(Number);
                onChange(numbers);
            }}
        />
    );
};
